import { Observable } from 'rxjs';
import * as moment from 'moment';

export abstract class AbstractCacheService<T> {
    readonly CACHE_DURATION_IN_MINUTES = 15;
    readonly MAX_CACHE_SIZE = 100;

    private cache: {
        [id: string]: {
            expires: Date,
            value: Observable<T>
        }
    } = {};


    getValue(key: any): Observable<T> {
        const item = this.cache[key];
        if (!item) {
            return null;
        }

        if (moment().isAfter(item.expires)) {
            return null;
        }

        return item.value;
    }

    setValue(key: any, value: Observable<T>) {
        const keys = Object.keys(this.cache);
        if (keys.length > this.MAX_CACHE_SIZE) {
            delete this.cache[keys[0]];
        }
        const expires = moment().add(this.CACHE_DURATION_IN_MINUTES, 'minutes').toDate();
        this.cache[key] = { expires, value };
    }

    evictCachedValue(key: any) {
        delete this.cache[key];
    }

    clearCache() {
        this.cache = {};
    }
}
